import { render, staticRenderFns } from "./Notfound.vue?vue&type=template&id=0b4334ec&scoped=true"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"
import style0 from "./Notfound.vue?vue&type=style&index=0&id=0b4334ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_2dde62133769d2ad31600f93390d89d2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4334ec",
  null
  
)

export default component.exports